module.exports = __webpack_public_path__ + "img/otoride.58433571.png";